<form>
<mat-card class="content-card" *ngIf="configs != null && configs.length != 0">
  <mat-card-header fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <mat-card-title>
      <h5>Invoices</h5>
    </mat-card-title>
    <div fxFlex></div>
  </mat-card-header>
  <mat-card-content>
    <div fxLayout="row" fxLayoutGap="5px" *ngFor="let config of configs">
      <mat-form-field fxFlex="20">
          <input matInput placeholder="{{orderSource[config.id]}}" disabled >
      </mat-form-field>
      <mat-form-field fxFlex="20" >
        <input matInput placeholder="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Enable Sending" style="display: none">
        <mat-checkbox [(ngModel)]="configs[config.id].enabled" matInput labelPosition="before" placeholder="Enable Sending" [ngModelOptions]="{standalone: true}"></mat-checkbox>
      </mat-form-field>
      <mat-form-field fxFlex="30">
        <mat-select [(ngModel)]="configs[config.id].emailTemplateId" matInput placeholder="Email template" [disabled]="!configs[config.id].enabled" [required]="configs[config.id].enabled" [ngModelOptions]="{standalone: true}">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field fxFlex="30">
        <mat-select [(ngModel)]="configs[config.id].pdfTemplateId" matInput placeholder="PDF template" [disabled]="!configs[config.id].enabled" [required]="configs[config.id].enabled" [ngModelOptions]="{standalone: true}">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let template of pdfTemplates" [value]="template.id">{{template.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-button (click)="submit()" >
      <mat-icon>done</mat-icon>
      <a>Save</a>
    </button>
  </mat-card-actions>
</mat-card>
</form>
